module.exports = __webpack_public_path__ + "static/media/1001004HG.3b0e5961.jpg";